module Meevo.Plugins.Client {
    export interface IClientSearchStrategyStatic {
        new(appSettings: Components.Common.IAppSettings, model: Model.Client, dataService: Meevo.Components.BaseClasses.IDataService, $q: ng.IQService): IClientSearchStrategy;
    }

    export interface IClientSearchStrategy {
        valid: boolean;
        search(options?: any): ng.IPromise<Model.Client[]>;
        showWarning(modalService: Meevo.Components.Modal.IModalService, clients: Model.Client[]): ng.IPromise<any>;
    }

    export abstract class ClientSearchStrategyBase implements IClientSearchStrategy {

        get valid(): boolean {
            return true;
        }

        constructor(protected appSettings: Components.Common.IAppSettings,
                    protected model: Model.Client,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected $q: ng.IQService) {
        }

        abstract search(options?: any): ng.IPromise<Model.Client[]>;

        abstract showWarning(modalService: Meevo.Components.Modal.IModalService, clients: Model.Client[]): ng.IPromise<any>;
    }
}
